import { cx } from '@linaria/core';
import React from 'react';

import { TextFieldLabelProps } from './types';
import { TEXT_FIELD_LABEL_QUIET_PROPS, TEXT_FIELD_LABEL_LOUD_PROPS } from './constants';

import styles from './styles';

const TextFieldLabel: React.FunctionComponent<TextFieldLabelProps> = (props) => {
  const { children, className, color, colorError, variant, id, hasError, ...restProps } = props;

  let textFieldVariantProps: TextFieldLabelProps;
  switch (true) {
    case variant === 'quiet':
      textFieldVariantProps = TEXT_FIELD_LABEL_QUIET_PROPS;
      break;
    case variant === 'loud':
      textFieldVariantProps = TEXT_FIELD_LABEL_LOUD_PROPS;
      break;
    default:
      textFieldVariantProps = TEXT_FIELD_LABEL_QUIET_PROPS;
      break;
  }

  const cssVariables = {
    [`--tui-text-field-label`]: color ?? textFieldVariantProps.color,
    [`--tui-text-field-label-error`]: colorError ?? textFieldVariantProps.colorError,
  } as React.CSSProperties;

  const style = cssVariables;

  const containerProps = {
    'data-error': hasError ? '' : undefined,
  };

  return (
    <label
      className={cx(styles.label, className)}
      style={style}
      htmlFor={id}
      {...containerProps}
      {...restProps}
    >
      {children}
    </label>
  );
};

export default TextFieldLabel;
